import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Card, Badge, Empty, inputCls, fmtDate } from "./ui";

const REASONS = ["", "purchase", "admin_adjust", "refund", "text", "voice", "image", "video", "learn", "agent"];

export function TransactionsSection() {
  const [f, setF] = useState({ type: "", reason: "", q: "", days: "30" });
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/admin/transactions", { params: { type: f.type || undefined, reason: f.reason || undefined, q: f.q || undefined, days: f.days || undefined } })
        .then(({ data }) => setRows(data.transactions)).catch(() => toast.error("Couldn't load transactions."));
    }, 250);
    return () => clearTimeout(t);
  }, [f]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const totalIn = (rows || []).filter((r) => r.type === "credit").reduce((s, r) => s + r.amount, 0);
  const totalOut = (rows || []).filter((r) => r.type === "debit").reduce((s, r) => s + r.amount, 0);
  return (
    <div className="space-y-3" data-testid="admin-transactions-section">
      <div className="grid grid-cols-2 gap-2">
        <select data-testid="txn-filter-type" value={f.type} onChange={set("type")} className={inputCls}>
          <option value="">All types</option><option value="credit">Credits in</option><option value="debit">Credits spent</option><option value="payment">Unpaid payment attempts</option>
        </select>
        <select data-testid="txn-filter-reason" value={f.reason} onChange={set("reason")} className={inputCls}>
          {REASONS.map((r) => <option key={r} value={r}>{r ? r.replace("_", " ") : "All reasons"}</option>)}
        </select>
        <input data-testid="txn-filter-user" value={f.q} onChange={set("q")} placeholder="User email…" className={inputCls} />
        <select data-testid="txn-filter-days" value={f.days} onChange={set("days")} className={inputCls}>
          <option value="7">Last 7 days</option><option value="30">Last 30 days</option><option value="90">Last 90 days</option><option value="">All time</option>
        </select>
      </div>
      {rows && <div className="text-xs text-slate-400" data-testid="txn-summary">{rows.length} entries · +{totalIn} in · −{totalOut} spent</div>}
      {rows === null ? <Empty>Loading…</Empty> : rows.length === 0 ? <Empty>No transactions match.</Empty> : (
        <div className="space-y-2" data-testid="txn-list">
          {rows.map((t) => (
            <Card key={t.txn_id} className="!p-3" data-testid="txn-row">
              <div className="flex justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-sm truncate">{t.email || t.user_id.slice(-6)}</div>
                  <div className="text-[11px] text-slate-400 mt-0.5 flex flex-wrap items-center gap-1.5">
                    {fmtDate(t.created_at)} · {t.reason.replace("_", " ")}
                    <Badge tone={t.status === "completed" ? "green" : t.status === "refunded" || t.status === "cancelled" ? "amber" : t.status === "failed" ? "red" : "slate"}>{t.status}</Badge>
                    {t.meta?.amount_inr != null && <span>₹{t.meta.amount_inr}</span>}
                    {t.meta?.free && <Badge tone="cyan">free</Badge>}
                  </div>
                  {t.meta?.note && <div className="text-[11px] text-slate-500 mt-0.5 break-words">“{t.meta.note}”{t.meta.admin_email ? ` — ${t.meta.admin_email}` : ""}</div>}
                </div>
                <div className={`shrink-0 text-sm ${t.type === "credit" ? "text-emerald-300" : "text-slate-200"}`} data-testid="txn-amount">
                  {t.type === "payment" ? `(${t.amount})` : `${t.type === "credit" ? "+" : "−"}${t.amount}`}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
